import React from "react";
import { Accordion, Button } from "react-bootstrap";
import ContactTable from "../../../../../components/b2b/ContactTable";

const Faqs = ({ setActiveTab }) => {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}>
      <h2 style={{ color: "#2c3e50", marginBottom: "20px" }}>FAQs for Collaborators</h2>
      <hr style={{ borderTop: "2px solid #2c3e50", marginBottom: "20px" }} />

      <Accordion flush>
        {/* General Main Accordion */}
        <Accordion.Item eventKey="general">
          <Accordion.Header>
            <h4 style={{ color: "#2c3e50", marginBottom: "0", fontWeight: "bold" }}>General</h4>
          </Accordion.Header>
          <Accordion.Body>
            <Accordion flush>
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <strong>What is Virtual B2B Forum?</strong>
                </Accordion.Header>
                <Accordion.Body>
                The Virtual B2B Forum is an online platform designed to connect Indian businesses and expert collaborators from around the world, facilitating meaningful business discussions and opportunities for both the sides.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <strong>What is the mission of the Virtual B2B Forum?</strong>
                </Accordion.Header>
                <Accordion.Body>
                The mission of the Virtual B2B Forum is to strengthen business connections between expert collaborators and Indian businesses, thus strengthening international trade ties and helping both sides to expand their reach globally.
                  <br />
                  Our Virtual B2B Forum is meant to facilitate the access to international collaborators through introductory interactive sessions and without involving financial investment.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3">
                <Accordion.Header>
                  <strong>What are the general trade queries and service requirements of B2B business participants?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  The primary goal for most businesses participating in these meetings is to seek guidance on business expansion. Our participants, ranging from new to established businesses, often have queries related to entering new markets, expanding within those markets, understanding regulatory or compliance requirements, and addressing legal matters such as contract drafting, trade disputes, and intellectual property rights (IPR) issues. They may also inquire about investment opportunities between countries.
                  <br />
                  We highly recommend exchanging business cards during the first meeting to foster future connections, allowing both parties to benefit from potential collaborations down the line.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Accordion.Body>
        </Accordion.Item>

        {/* Business Opportunities Main Accordion */}
        <Accordion.Item eventKey="business">
          <Accordion.Header>
            <h4 style={{ color: "#2c3e50", marginBottom: "0", fontWeight: "bold" }}>Business Opportunities</h4>
          </Accordion.Header>
          <Accordion.Body>
            <Accordion flush>
              <Accordion.Item eventKey="4">
                <Accordion.Header>
                  <strong>How are the business participants selected for the B2B platform?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  Business participants in our B2B sessions are primarily our registered trade members who seek our assistance with their business and shipment-related services. As part of the registration process, we collect their profile information and authentication documents. Based on this, we invite qualified members to participate in our B2B meetings, ensuring they are the right participants for the platform.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5">
                <Accordion.Header>
                  <strong>How do you keep things discreet?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  We understand the sensitivity of the information we handle and take every possible measure to maintain its confidentiality. Before onboarding any participant or collaborator, we follow a thorough process that includes discussion, application, reviewing their profile and relevant documents. Only after this due diligence and signing the agreement, we gain the confidence to bring them on board for B2B sessions.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="6">
                <Accordion.Header>
                  <strong>How do you decide whether or not to approve a B2B meeting request?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  Each meeting request is carefully reviewed to identify the seriousness of businesses so that to extend maximum benefit from the opportunities offered by the Virtual B2B Forum. Incomplete application or wrong information on B2B platform may lead to rejection of meeting request.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="7">
                <Accordion.Header>
                  <strong>Who is responsible for controlling the B2B Sessions?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  All B2B Sessions facilitated through our Virtual B2B Forum are managed and monitored by our B2B team. While we do not directly participate in the discussions between experts and business participants, team remains actively available throughout the meeting. B2B team keeps ready to provide any technical or other support needed to ensure the meeting runs smoothly and according to the given schedule.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="8">
                <Accordion.Header>
                  <strong>How do I get an update on the status of my B2B Sessions?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  Our Virtual B2B platform is designed for the convenience of both parties. Expert collaborators can provide multiple available time slots directly on the platform, and Indian participants can request for appointments based on the available options. <br /> All details regarding your meeting schedule or other updates, will be available in your digital account on our platform.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="9">
                <Accordion.Header>
                  <strong>How much time is generally available for each session and for discussing business?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  Each meeting on our Virtual B2B Forum is allocated a 30-minute slot. Video conferencing windows are opened in advance for audio-video testing, and the remaining 30 minutes are dedicated to discussion. <br /> We encourage our collaborative partners to address as many queries as possible during this first introductory session, with the goal of building strong relationships and in order to secure potential future clients.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="10">
                <Accordion.Header>
                  <strong>How can I prepare to get the maximum outcome from the B2B Sessions? </strong>
                </Accordion.Header>
                <Accordion.Body>
                  We insist our business participants to share their profile and probable points of discussion in advance so that the expert collaborator can keep ready to handle the relevant queries. Additionally, exchanging business cards at the end of the meeting is a great way to establish future connections and strengthen ongoing business relationships.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="11">
                <Accordion.Header>
                  <strong>I couldn’t find any appointment requests for my country on the B2B platform. What can I do about it?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  If there are fewer or no B2B session requests for your country on the platform, we can increase visibility by advertising your profile.
                  <br />
                  Additionally, we can schedule a webinar or an "Ask Me Anything" session with you, which will help us to introduce you to our trade members and generate future connections.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="12">
                <Accordion.Header>
                  <strong>What happens if the other side doesn’t want to cooperate during the B2B Session?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  Although such situations are rare, if you come across such a business participant who is showing disinterest, it may be due to a language barrier or technical issues on other side. In such cases, please send us your feedback. <br /> We will follow up with the business participant and, if necessary, will facilitate written communication (via email) between both parties to address any concerns.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="13">
                <Accordion.Header>
                  <strong>I’ve changed my mind and no longer wish to continue with the scheduled B2B Session. Can I request to change the schedule?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  If the session has not yet been confirmed by the business participant, you can certainly make the changes according to your availability. However, if the meeting has already been confirmed, it may be little difficult to make changes. In that case, please inform us directly, and we will do our best to work with the business participant to reschedule the session.
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="14">
                <Accordion.Header>
                  <strong>What happens if my B2B Sessions didn’t succeed?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  While we make every effort to ensure successful sessions, there are times when outcomes may not meet expectations due to factors beyond our control. We recommend exchanging business cards with your business participant so you can explore further opportunities at a later time.
                </Accordion.Body>
              </Accordion.Item>


              <Accordion.Item eventKey="15">
                <Accordion.Header>
                  <strong>In which time zone should collaborators schedule sessions?</strong>
                </Accordion.Header>
                <Accordion.Body>
                  All meetings must be scheduled in Indian Standard Time (IST) [GMT+5:30]. Collaborators are advised to select their preferred time slots accordingly. Each meeting will have a duration of 30 minutes.
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>

      <h4 style={{ color: "#34495e", marginBottom: "15px" }} className="mt-4">
        <strong>Team Members</strong>
      </h4>
      <hr style={{ borderTop: "2px solid #2c3e50", marginBottom: "20px" }} />
      <ContactTable />
      <div className='d-flex justify-content-center mt-4'>
        <Button onClick={() => setActiveTab("Registration")}>Register Now</Button>
      </div>
    </div>
  );
};

export default Faqs;